import * as actionTypes from "./actionTypes";
import * as actions from "store/actions/index";
import { updateObject } from "../utility";
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import { saveUploadInfo } from "Flow2/components/CustomCollections/CustomDataLog/CustomDataLog";

export const uploadFormState = (formState) => {
  return {
    type: actionTypes.UPLOAD_FORM_STATE,
    payload: formState
  }
}

export const uploadFileStart = () => {
  return {
    type: actionTypes.UPLOAD_FILE_START
  };
};

export const uploadFileSuccess = () => {
  return {
    type: actionTypes.UPLOAD_FILE_SUCCESS
  };
};

export const uploadFileSuccessMaster = () => {
  return {
    type: actionTypes.UPLOAD_FILE_SUCCESS_MASTER
  };
};

export const uploadFileFail = error => {
  return {
    type: actionTypes.UPLOAD_FILE_FAIL,
    error: error
  };
};

export const uploadFileFailMaster = error => {
  return {
    type: actionTypes.UPLOAD_FILE_FAIL_MASTER,
    error: error
  };
};

export const uploadFileAborted = error => {
  return {
    type: actionTypes.UPLOAD_FILE_ABORTED,
    error: error
  };
};

export const uploadFileAbortedMaster = error => {
  return {
    type: actionTypes.UPLOAD_FILE_ABORTED_MASTER,
    error: error
  };
};

export const uploadFileProgress = pcObj => {
  return {
    type: actionTypes.UPLOAD_FILE_PROGRESS,
    pcObj: pcObj
  };
};

export const uploadFileProgressMaster = pcObj => {
  return {
    type: actionTypes.UPLOAD_FILE_PROGRESS_MASTER,
    pcObj: pcObj
  };
};


export const uploadSetState = () => {
  return {
    type: actionTypes.UPLOAD_SET_STATE
  };
};

export const uploadSetStateMaster = () => {
  return {
    type: actionTypes.UPLOAD_SET_STATE_MASTER
  };
};

export const uploadSaveUploadedData = (uploadedObj) => {
  return {
    type: actionTypes.UPLOAD_SAVE_UPLOADEDDATA,
    payload: uploadedObj
  }
}

export const uploadImportFileFail = error => {
  return {
    type: actionTypes.UPLOAD_IMPORT_FILE_FAIL,
    error: error
  };
};

export const uploadImportFileFailMaster = error => {
  return {
    type: actionTypes.UPLOAD_IMPORT_FILE_FAIL_MASTER,
    error: error
  };
};

export const uploadEditClipStart = () => {
  return {
    type: actionTypes.UPLOAD_EDIT_CLIP_START
  };
};

export const uploadEditClipSuccess = () => {
  return {
    type: actionTypes.UPLOAD_EDIT_CLIP_SUCCESS
  };
};

export const uploadEditClipFail = error => {
  return {
    type: actionTypes.UPLOAD_EDIT_CLIP_FAIL,
    error: error
  };
};

export const uploadProjectAddClipStart = () => {
  return {
    type: actionTypes.UPLOAD_PROJECT_ADD_CLIP_START
  };
};

export const uploadProjectAddClipSuccess = () => {
  return {
    type: actionTypes.UPLOAD_PROJECT_ADD_CLIP_SUCCESS
  };
};

export const uploadProjectAddClipFail = error => {
  return {
    type: actionTypes.UPLOAD_PROJECT_ADD_CLIP_FAIL,
    error: error
  };
};

export const uploadRoomAddClipSuccess = () => {
  return {
    type: actionTypes.UPLOAD_ROOM_ADD_CLIP_SUCCESS
  };
};

export const uploadRoomAddClipFail = error => {
  return {
    type: actionTypes.UPLOAD_ROOM_ADD_CLIP_FAIL,
    error: error
  };
};


export const checkFileAsThumb = ({ mode, id, tags, file }) => {
  /*if (tags && tags.includes("thumb_newstv") && DataUtil.isPMDB() && DataUtil.isJpegFile(file)) {
    return { mode: 'addmainthumb', id, tags, asThumb: true };
  }*/
  return { mode, id, tags }
}

export function getStatusProgress(dispatch, file, counter, startActionTime, uploadMessageId, appId = null) {
  let getUploadState = async function () {
    let uploadState = await window.flow.getUploadState();
    if (!uploadState.aborted) {
      var serverpc = uploadState.pc;

      if (uploadState.pcfile === file.name) {
        let actionTime;
        if (startActionTime > 0)
          actionTime = Date.now() - startActionTime;
        else actionTime = 0;
        var pcObj = updateObject({}, { id: counter, fileId: file.fileId, filename: file.name, uploading: serverpc, actionTime, uploadMessageId });
        if (DataUtil.isUpMaster(appId)) {
          //console.log("LAMTEST MASTER pcObj", pcObj, pcObj.uploading);
          dispatch(uploadFileProgressMaster(pcObj));
        }
        else {
          // console.log("LAMTEST pcObj", pcObj, pcObj.uploading)
          dispatch(uploadFileProgress(pcObj));
        }
      }
    }
  };
  getUploadState();
};

export function checkActionTimeout(dispatch, startActionTime, timerId, appId = null) {
  if (startActionTime > 0) {
    let time = Date.now() - startActionTime;
    if (DataUtil.checkTimeout(time)) {
      if (DataUtil.isUpMaster(appId)) dispatch(uploadImportFileFailMaster());
      else dispatch(uploadImportFileFail());
      let timeOut = DataUtil.getCurrentDayTimestamp();
      let info = { [`${timeOut}.ServerConnectionError`]: "Server Connection Error like timeout, logout, etc.", "isLoading": false };
      if (DataUtil.isUpMaster(appId)) dispatch(actions.setCustomUploadInfoMaster(info));
      else dispatch(actions.setCustomUploadInfo(info));
      clearInterval(timerId);
    }
  }
}

export async function startImportFile(dispatch, infoCounter, localfile, importObj, appId = null, isPostUp = false) {
  let startActionTime = Date.now();
  try {
    //let importRes = importRes = await window.flow.importFile(localfile, importObj);
    let importRes;
    console.log("LOGS: sdkPostUpload", importObj);
    if (DataUtil.isSdk() && isPostUp) {
      importRes = await window.flow.sdkPostUpload(localfile, importObj);
    }
    else importRes = await window.flow.importFile(localfile, importObj);
    saveUploadInfo(dispatch, importRes, infoCounter, 'ImportFileStatus');
    if (!importRes.success) {
      if (DataUtil.isUpMaster(appId)) dispatch(uploadImportFileFailMaster());
      else dispatch(uploadImportFileFail());
    }
    if (importRes.clipid) startActionTime = 0;
    if (importObj && importObj.asThumb) {
      setTimeout(() => dispatch(actions.updateMetadata("clip", importObj.id, {})), 2000);
    }

  } catch (error) {
    console.log("LAMTEST ImportFileError", error);
    saveUploadInfo(dispatch, error, infoCounter, 'ImportFileStatus', appId);
  }

  return startActionTime;
}

export function updateMetadata(obj, metadata, len, id) {
  if ((obj.appId === CustomTypes.MASTER_UPLOAD_FORM)) {
    return metadata;
  }
  if (len >= 2) {
    let newTitle = DataUtil.changeTitleByAppId(metadata, id);
    return { ...metadata, ...newTitle };
  }
  return metadata;
}

export function uploadSendEmail(dispatch, infoCounter, obj, clipId, getState) {
  let email = getState().auth.user.email || getState().auth.user.originalObject.email || "";
  if (obj.sendEmail && obj.sendEmail === 1) {
    saveUploadInfo(dispatch, "Starting", infoCounter, 'SendEmail');
    dispatch(actions.sendEmail(DataUtil.sendMessageEmail(clipId, email)));
  }
}

export function uploadCreateNewEntry(obj) {
  return (dispatch) => {
    let metadata = DataUtil.getMetadata(obj);
    saveUploadInfo(dispatch, metadata, '', 'newClipStart');
    //  window.flow.newClip(metadata).then(res => {
    window.flow.newClip({ ...metadata }).then(res => {
      if (res && res.data && res.data.metadata && res.data.metadata.fields) {
        //startActionTime = 0;
        saveUploadInfo(dispatch, "success", '', 'newClipStatus');
        saveUploadInfo(dispatch, res.data.metadata.fields, '', 'NewClipFields');
      }
      dispatch(actions.createNewEntrySuccess(res));
    }).catch(err => {
      console.log("LAMTEST uploadCreateNewEntry ERROR");
      saveUploadInfo(dispatch, err, '', 'newClipError');
      dispatch(actions.createNewEntryFail(err));
    })
  }
}

const addClipToRoom = ({ dispatch, obj, importRes, infoCounter }) => {
  saveUploadInfo(dispatch, obj.room, infoCounter, 'AddToRoom');
  return window.flow.projectAddClip(obj.room, importRes.clipid)
    .then(res => saveUploadInfo(dispatch, "success", infoCounter, 'AddToRoomStatus'))
    .catch(e => saveUploadInfo(dispatch, e, infoCounter, 'AddToRoomStatus'))
}

const addClipToProject = ({ dispatch, obj, importRes, infoCounter }) => {
  saveUploadInfo(dispatch, obj.project, infoCounter, 'AddToProject');
  return window.flow.projectAddClip(obj.project, importRes.clipid)
    .then(res => {
      saveUploadInfo(dispatch, "success", infoCounter, 'AddToProjectStatus');
    })
    .catch(e => saveUploadInfo(dispatch, e, infoCounter, 'AddToProjectStatus'))
}

const addClipToDistribution = ({ dispatch, obj, importRes, infoCounter }) => {
  saveUploadInfo(dispatch, obj.distribution, infoCounter, 'AddToDistribution');
  return window.flow.distprojectAddClip(obj.distribution, importRes.clipid)
    .then(res => {
      saveUploadInfo(dispatch, "success", infoCounter, 'AddToDistributionStatus');
      if (res && DataUtil.isVifogra()) {
        dispatch(actions.getClipsForClipList('distribution', obj.distribution));
      }
    })
    .catch(e => saveUploadInfo(dispatch, e, infoCounter, 'AddToDistributionStatus'))
}

const addClipToEventroom = ({ dispatch, obj, importRes, infoCounter }) => {
  saveUploadInfo(dispatch, obj.eventroom, infoCounter, 'AddToEventRoom');
  return window.flow.distprojectAddClip(obj.eventroom, importRes.clipid)
    .then(res => {
      saveUploadInfo(dispatch, "success", infoCounter, 'AddToEventroomStatus');
      if (res && DataUtil.isVifogra()) {
        dispatch(actions.getClipsForClipList('eventroom', obj.eventroom));
      }
    })
    .catch(e => saveUploadInfo(dispatch, e, infoCounter, 'AddToDistributionStatus'))
}

const setNewsroomData = ({ metadata, getState }) => {
  if (getState().ui.config && getState().ui.config.DISTRIBUTION_CHANNELS
    && getState().ui.config.DISTRIBUTION_CHANNELS.Newsroom) {
    const { languages } = getState().ui.config.DISTRIBUTION_CHANNELS.Newsroom;
    if (languages && languages.length) {
      let de_lg = languages.filter(item => item.toLowerCase().startsWith("de")).map(item => item.toLowerCase());
      let en_lg = languages.filter(item => item.toLowerCase().startsWith("en")).map(item => item.toLowerCase());
      if (metadata && metadata.titel && en_lg && en_lg.length) {
        en_lg.forEach(lg => metadata[`distribution_json_${lg}-newsroom-description`] = "");
      }
      if (metadata && metadata.titel_de && de_lg && de_lg.length) {
        de_lg.forEach(lg => metadata[`distribution_json_${lg}-newsroom-description`] = "");
      }
      if (metadata && metadata.title && en_lg && en_lg.length) {
        en_lg.forEach(lg => metadata[`distribution_json_${lg}-newsroom-title`] = metadata.title);
        //en_lg.forEach(lg => metadata[`distribution_json_${lg}-newsroom-title`] = "");
      }
      if (metadata && metadata.description_de && de_lg && de_lg.length) {
        de_lg.forEach(lg => metadata[`distribution_json_${lg}-newsroom-title`] = metadata.description_de);
      }
    }
  }

  return metadata;
}

/*
* FUNCTION: uploadFile
*/
export function uploadFile(obj) {
  let appId = obj.appId;
  let isPostUp = false;
  if (obj.user && obj.user.isPostUp) {
    isPostUp = true;
    delete obj.user.isPostUpload;
  }
  return (dispatch, getState) => {
    let workflow = (DataUtil.isFrancetv() && (obj.workflow !== undefined && obj.workflow !== "")) ? obj.workflow : null;
    let metadata = DataUtil.getMetadata(obj);
    if (DataUtil.isPMDB() && obj.appId !== CustomTypes.MASTER_UPLOAD_FORM) {
      metadata = setNewsroomData({ metadata, getState });
    }
    let files = [...obj.selectedObjects];
    let len = files.length;
    let counter = 0;
    let timerId;
    let file;
    let isFirst = true;
    let firtClipId;
    let startActionTime;
    let uploadMessageId = "uploadingMsg";
    let infoCounter = 1;
    let postUpId;
    if (getState().customData.customUploadInfo) {
      const { lastUploadCount } = getState().customData.customUploadInfo;
      if (lastUploadCount) infoCounter = lastUploadCount + 1;
    }
    saveUploadInfo(dispatch, "Starting", infoCounter, 'Upload', appId);
    saveUploadInfo(dispatch, metadata, "", 'Metadata', appId);
    let startUpload = async function () {
      file = files.shift();
      uploadMessageId = "uploadingMsg";
      let currentTime = DataUtil.getCurrentDayTimestamp;
      saveUploadInfo(dispatch, file.name, infoCounter, 'UploadFileStart', appId);
      saveUploadInfo(dispatch, file.file.size, infoCounter, 'UploadFilesize', appId);
      window.flow.uploadFileWithCancel(file.file).promise.then(res => {
        saveUploadInfo(dispatch, "success", infoCounter, 'UploadFileStatus', appId);
        let startImport = async function () {
          let uploadState = await window.flow.getUploadState();
          if (!uploadState.aborted) {
            //dispatch(uploadImportFileStart());
            let fileMetadata = updateMetadata(obj, metadata, len, file.fileId);
            if (res.localfile) {
              uploadMessageId = "importingMsg";
              saveUploadInfo(dispatch, res.localfile, infoCounter, 'ImportFileStart', appId);
              if (obj.oneClip && !isFirst && (firtClipId || postUpId)) {
                let impObj = { mode: "add", id: firtClipId };
                if (isPostUp && postUpId) impObj = { mode: "add", "ulid": postUpId };
                startActionTime = startImportFile(dispatch, infoCounter, res.localfile, impObj, appId, isPostUp);
              }
              if ((obj.appId === CustomTypes.MASTER_UPLOAD_FORM) && obj.masterClipId) {
                saveUploadInfo(dispatch, metadata.tags, infoCounter, 'metadataTags', appId);
                if (DataUtil.isFrancetv() && (workflow !== undefined && workflow !== "")) {
                  saveUploadInfo(dispatch, `${workflow}`, infoCounter, 'MasterUploadAddToWorkflow', appId);
                  let options = { mode: 'add', id: obj.masterClipId, tags: metadata.tags, workflow: workflow };
                  if (metadata.tags.includes("useasthumbnail")) options = { mode: 'addmainthumb', id: obj.masterClipId, workflow: workflow };
                  startActionTime = startImportFile(dispatch, infoCounter, res.localfile, options, appId, isPostUp);
                } else {
                  let options = checkFileAsThumb({ mode: "add", id: obj.masterClipId, tags: metadata.tags, file: res.localfile });
                  startActionTime = startImportFile(dispatch, infoCounter, res.localfile, options, appId, isPostUp);
                }
              }
              if (((obj.oneClip && isFirst) || (!obj.oneClip)) && (obj.appId !== CustomTypes.MASTER_UPLOAD_FORM)) {
                startActionTime = Date.now();
                try {
                  let importRes;
                  if (DataUtil.isFrancetv() && (workflow !== undefined && workflow !== "")) {
                    saveUploadInfo(dispatch, `${workflow}`, infoCounter, 'UploadAddToWorkflow');
                    importRes = await window.flow.importFile(res.localfile, { workflow: workflow, metadata: fileMetadata });
                  }
                  else {
                    if (DataUtil.isSdk() && isPostUp) {
                      let newPostRes = await window.flow.sdkPostUpload(res.localfile, { metadata: fileMetadata });
                      if (newPostRes && newPostRes.ulid && obj.oneClip) {
                        postUpId = newPostRes.ulid;
                        isFirst = false;
                      }
                    } else {
                      importRes = await window.flow.importFile(res.localfile, { metadata: fileMetadata });
                    }
                  }
                  if (importRes) saveUploadInfo(dispatch, importRes, infoCounter, 'ImportFileStatus', appId);
                  if (importRes.clipid) {
                    uploadSendEmail(dispatch, infoCounter, obj, importRes.clipid, getState);
                    if (obj.oneClip) {
                      firtClipId = importRes.clipid;
                      isFirst = false;
                    }
                    if (obj.project) {
                      uploadMessageId = "addIntoProjectMsg";
                      await addClipToProject({ dispatch, obj, importRes, infoCounter });
                    }
                    if (obj.room) {
                      uploadMessageId = "addIntoRoomMsg";
                      await addClipToRoom({ dispatch, obj, importRes, infoCounter });
                    }
                    if (obj.distribution) {
                      uploadMessageId = "addIntoDistributionMsg";
                      await addClipToDistribution({ dispatch, obj, importRes, infoCounter });
                    }

                    if (obj.eventroom) {
                      uploadMessageId = "addIntoEventroomMsg";
                      await addClipToEventroom({ dispatch, obj, importRes, infoCounter });
                    }

                    startActionTime = 0;
                  }
                } catch (error) {
                  saveUploadInfo(dispatch, error, infoCounter, 'ImportFileStatus', appId);
                }
              }
            }
            if (files.length > 0) {
              counter++;
              infoCounter++;
              startUpload();
            } else {
              window.clearInterval(timerId);
              if (DataUtil.isUpMaster(appId)) dispatch(uploadFileSuccessMaster());
              else dispatch(uploadFileSuccess());
              let info = { [`${currentTime()}.UploadFiles`]: "done", "lastUploadCount": infoCounter };
              if (DataUtil.isUpMaster(appId)) {
                dispatch(actions.setCustomUploadInfoMaster(info));
              } else dispatch(actions.setCustomUploadInfo(info));
            }
          } else {
            window.clearInterval(timerId);
          }
        }
        startImport();
      })
        .catch(error => {
          saveUploadInfo(dispatch, error, infoCounter, 'UploadFileError');
          window.clearInterval(timerId);
          if (DataUtil.isUpMaster(appId)) dispatch(uploadFileFailMaster("uploadFileFail"));
          else dispatch(uploadFileFail("uploadFileFail"));
        });
    };

    startUpload();
    timerId = window.setInterval(() => {
      getStatusProgress(dispatch, file, counter, startActionTime, uploadMessageId, appId);
      checkActionTimeout(dispatch, startActionTime, timerId, appId);
    }, 100);
  };
}

export function uploadCancel(appId = null) {
  let cancelTime = DataUtil.getCurrentDayTimestamp();
  return dispatch => {
    let info = { [`${cancelTime}.UploadFileCancel`]: "Cancelled", "isLoading": false };
    if (DataUtil.isUpMaster(appId)) dispatch(actions.setCustomUploadInfoMaster(info));
    else dispatch(actions.setCustomUploadInfo(info));
    window.flow.cancelUpload();
    let error = "";
    if (DataUtil.isUpMaster(appId)) dispatch(uploadFileAbortedMaster(error));
    else dispatch(uploadFileAborted(error));
  }
}
